import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ParagraphSearchComponent } from './paragraph-search/paragraph-search.component';
import { ResultComponent } from './result/result.component';
import { AboutusComponent } from './aboutus/aboutus.component';
import {HelpComponent} from "./help/help.component";
const routes: Routes = [
  {
    path: 'search',
    component: ResultComponent,
    data: { title: 'සෙවුම්', type: 'search' },
  },
  {
    path: 'history',
    component: ResultComponent,
    data: { title: 'පෙර සෙවුම්', type: 'history' },
  },
  {
    path: 'favourite',
    component: ResultComponent,
    data: { title: 'ප්‍රියතම වචන', type: 'favourite' },
  },
  {
    path: 'aboutus',
    component: AboutusComponent,
    data: { title: 'අපි ගැන'},
  },
  {
    path: 'help',
    component: HelpComponent,
    data: { title: 'උදව්'},
  },
  {
    path: 'paragraph-search',
    component: ParagraphSearchComponent,
    data: { title: 'ඡේදයක වචන'},
  },
  {
    path: '',
    pathMatch: 'full',
    component: HomeComponent,
    data: { title: '' },
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
